module.exports = {
  NODE_ENV: '"production"'
}



//////////////////
// WEBPACK FOOTER
// ./config/prod.env.js
// module id = 74
// module chunks = 40